import { Injectable, OnDestroy } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Keyboard, KeyboardResize, KeyboardInfo } from '@capacitor/keyboard';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class KeyboardBridgeService implements OnDestroy {
  public keyboardWillShow = new Subject<KeyboardInfo>();
  public keyboardDidHide = new Subject<void>();

  private initialized = false;
  private currentHeight = 0;
  private debounceTimer: any = null;

  async init() {
    if (this.initialized || Capacitor.getPlatform() === 'web') return;

    await Keyboard.setResizeMode({ mode: KeyboardResize.None });

    const set = (h = 0) => {
      document.documentElement.style.setProperty('--kb-height', `${h}px`);
      if (h > 0) {
        document.body.classList.add('keyboard-open');
      } else {
        document.body.classList.remove('keyboard-open');
      }
    };

    const handleShow = (e: KeyboardInfo) => {
      const newHeight = e.keyboardHeight ?? 0;
      clearTimeout(this.debounceTimer);

      this.debounceTimer = setTimeout(() => {
        if (newHeight === this.currentHeight) return;

        this.currentHeight = newHeight;
        set(this.currentHeight);

        this.keyboardWillShow.next(e);
      }, 100);
    };

    const handleHide = () => {
      clearTimeout(this.debounceTimer);
      if (this.currentHeight === 0) return;

      this.currentHeight = 0;
      set(this.currentHeight);

      this.keyboardDidHide.next();
    };

    await Keyboard.addListener('keyboardWillShow', handleShow);
    await Keyboard.addListener('keyboardWillHide', handleHide);
    await Keyboard.addListener('keyboardDidHide', handleHide);

    this.initialized = true;
  }

  async ngOnDestroy() {
    clearTimeout(this.debounceTimer);
    this.currentHeight = 0;
    await Keyboard.removeAllListeners();
  }
}
